// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-suggestion-user[data-v-c93314d0] {\n  min-width: 260px;\n}", ""]);
// Exports
module.exports = exports;
